<p-select
  class="bn-care-plan-status-select"
  [options]="options()"
  optionLabel="label"
  optionValue="code"
  appendTo="body"
  panelStyleClass="bn-care-plan-status-overlay"
  [ariaLabel]="ariaLabel()"
  [placeholder]="placeholder()"
  [ngModel]="value()"
  [loading]="loading()"
  [disabled]="disabled()"
  (ngModelChange)="valueChange.emit($event)"
>
  <ng-template #selectedItem let-selectedOption>
    {{ selectedOption?.label || placeholder() }}
  </ng-template>
</p-select>
